import { useQueryClient } from 'react-query'
import { informalFeedbackRequestsKeys } from './queries/informalFeedbackRequests/informalFeedbackRequestsKeys'

interface Props {
  almanacFileId?: string
  requestId?: number
}

export const useRefreshInformalFeedbackRequests = ({ almanacFileId, requestId }: Props) => {
  const queryClient = useQueryClient()

  const refreshRequests = async () => {
    if (almanacFileId) queryClient.invalidateQueries(informalFeedbackRequestsKeys.forAlmanacFile(almanacFileId))
    if (requestId) queryClient.invalidateQueries(informalFeedbackRequestsKeys.detail(requestId))
  }

  return {
    refreshRequests,
  }
}
